import React from 'react';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataAionCloud } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import BreadcrumbAiMl from '../Breadcrumb';
import { Link } from 'react-router-dom';
import { pageRoutes } from 'src/shared/utils/pageRoutes.constant';

const AiOnTheCloud = () => {
  return (
    <div className="page-container-ai-on-cloud">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
          <h1 className='heading drop-in'>AI on the Cloud</h1>
          </div>
            <Link to={pageRoutes.AiOnCloud} className='no-decoration '><BreadcrumbAiMl text={'AI on the Cloud'} /></Link>
            <div className='red-bg-box'></div>
        </div>

        <CardsServices cardDataServices={cardDataAionCloud} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default AiOnTheCloud